export enum SpinnerType {
    None,
    Spinner,
    Progress,
    Skeleton
}
